module.exports = __webpack_public_path__ + "static/img/nav.5cdf88a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav.jpg
// module id = DhYZ
// module chunks = 62